import React, { useRef, useState, useEffect } from "react";
import { EditProfileImage } from "../../../../components/superadmin";
import { TbTrashX } from "react-icons/tb";
import { BiCloudUpload } from "react-icons/bi";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { handleApi } from "../../../../utils/authentication";
import Select from "react-select";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import campaign from "../../../../assests/program.png";
import user_default from "../../../../assests/user_default.png";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "44px", // minimum height of the control
    // height: '44px',  // fixed height
    fontSize: "14px", // adjust font size if needed
    fontFamily: "aeonik_medium", // customize font family
    border: state.isFocused ? "1px solid #007bff" : "1px solid #ced4da", // border style
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
    borderRadius: "8px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    // height: '44px',
    minHeight: "44px",

    overflowY: "auto",
    "::-webkit-scrollbar": {
      display: "none",
    },
    msOverflowStyle: "none" /* IE and Edge */,
    scrollbarWidth: "none",

    padding: "0 8px", // adjust padding to align text
    display: "flex",
    alignItems: "center",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    height: "44px",
  }),
  singleValue: (provided) => ({
    ...provided,
    lineHeight: "44px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    // height: '44px',
  }),
  indicatorSeparator: () => ({
    display: "none", // remove the default indicator separator
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
    color: "#7F56D9",
  }),
};

function CampaignViewEdit({
  show,
  setShow,
  campaign_id,
  setCampaignId,
  program,
}) {
  const handleClose = () => {
    setImageUri("");
    setFile(null);
    formik.resetForm();
    setCampaignId(null);
    setShow(false);
  };

  const user = useSelector((state) => state?.user);
  const [isLoading, setIsLoading] = useState(false);
  const [imageUri, setImageUri] = useState("");
  const [file, setFile] = useState(null);
  const profileImageRef = useRef(null);
  const [programList, setProgramList] = useState([]);
  const [userList, setUserList] = useState([]);
  //show image showing modal
  const [editImage, setEditImage] = useState(false);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUri(reader.result);
        setEditImage(true);
      };
      reader.readAsDataURL(file);
      setFile(file);
      event.target.value = "";
    }
  };

  //creating a campaign

  const handleCreateCampaign = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};

      let formData = new FormData();
      if (imageUri && file) {
        let response = await fetch(imageUri);
        let image_file = await response?.blob();
        formData.append("campaign_image", image_file, file?.name);
      }
      // formik?.values?.program_ids.forEach((element, index) => {
      //   formData.append(`program_ids[${index}]`, element.value)
      // });
      formData.append(`program_ids[${0}]`, formik?.values?.program_ids?.value);
      formik?.values?.user_ids.forEach((element, index) => {
        formData.append(`user_ids[${index}]`, element.value);
      });
      formData.append("campaign_name", formik?.values?.campaign_name);
      formData.append(
        "start_date",
        format(
          new Date(formik?.values?.start_date),
          "MM/dd/yyyy"
        )
      );
      formData.append(
        "end_date",
        format(
          new Date(formik?.values?.end_date),
          "MM/dd/yyyy"
        )
      );
      formData.append("created_by", user?.user_id);

      let result = await handleApi(
        "create_campaign",
        method,
        headers,
        formData
      );

      if (result?.success) {
        toast.success(
          result?.data?.message
            ? result?.data?.message
            : "Program created successfully"
        );
        setShow(false);
        setImageUri("");
        setFile(null);
        formik.resetForm();
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to create campaign"
        );
      }
      setIsLoading(false);
    } catch (e) {
      toast.error(e.message ? e.message : "Failed to create campaign");
    }
  };

  const handleUpdateCampaign = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};

      let formData = new FormData();
      if (imageUri && file) {
        let response = await fetch(imageUri);
        let image_file = await response?.blob();
        formData.append("campaign_image", image_file, file?.name);
      }
    
      // formik?.values?.program_ids.forEach((element, index) => {
      //   formData.append(`program_ids[${index}]`, element.value)
      // });
      formData.append(`program_ids[${0}]`, formik?.values?.program_ids?.value);
      formik?.values?.user_ids.forEach((element, index) => {
        formData.append(`user_ids[${index}]`, element.value);
      });
      formData.append("campaign_name", formik?.values?.campaign_name);
      formData.append("campaign_id", campaign_id);
      formData.append(
        "start_date",
        format(
          new Date(formik?.values?.start_date),
          "MM/dd/yyyy"
        )
      );
      formData.append(
        "end_date",
        format(
          new Date(formik?.values?.end_date),
          "MM/dd/yyyy"
        )
      );

      let result = await handleApi("edit_campaign", method, headers, formData);

      if (result?.success) {
        toast.success(
          result?.data?.message
            ? result?.data?.message
            : "Campaign updated successfully");
        setShow(false);
        setImageUri("");
        setFile(null);
        formik.resetForm();
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to update campaign"
        );
      }
    } catch (e) {
      console.log(e);

      toast.error(e.message ? e.message : "Failed to update campaign");
    } finally {
      setIsLoading(false);
    }
  };
  const today = new Date();
  const validationSchema = Yup.object({
    campaign_name: Yup.string().required("Campaign name is required"),
    start_date: Yup.date()
      .required("Start date is required")
      .nullable(),
      end_date: Yup.date()
      .required("End date is required")
      .nullable()
      .min(today, "End date must be greater than today's date")
      .when("start_date", (start_date, schema) => {
        if (start_date && start_date instanceof Date && !isNaN(start_date.getTime())) {
          return schema.min(start_date, "End date must be greater than start date");
        }
        return schema;
      }),

    program_ids: Yup.object().required("Programs are required"),
    user_ids: Yup.array()
      .min(1, "At least one member is required")
      .required("Members are required"),
  });

  const formik = useFormik({
    initialValues: {
      campaign_name: "",
      program_ids: {},
      user_ids: [],
      start_date: null,
      end_date: null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (campaign_id) {
        //updating existing campaign
        handleUpdateCampaign();
      } else {
        //creating new campaign
        handleCreateCampaign();
      }
    },
  });

  //getting campaign details
  const getCampaignDetails = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("campaign_id", campaign_id);
      let result = await handleApi("view_campaign", method, headers, formData);
      if (result?.success) {
        let program_ids = {
          label: program?.program_name,
          value: program?.program_id,
        };
        result?.data?.campaign_info?.program_ids.forEach((program) => {
          let program_details = programList.find(
            (item) => item?.program_id === program?.program_id
          );
          if (program_details) {
            program_ids = {
              label: program_details?.program_name,
              value: program_details?.program_id,
            };
          }
        });

        let user_ids = [];
        result?.data?.campaign_info?.user_ids.forEach((user) => {
          let user_details = userList.find(
            (item) => item?.user_id === user?.user_id
          );
          if (user_details) {
            user_ids.push({
              label: `${user_details.first_name} ${user_details.last_name}`,
              value: user_details?.user_id,
              customLabel: (
                <div className="d-flex align-items-center gap-2">
                  <img
                    src={
                      user_details?.profile_image
                        ? user_details?.profile_image
                        : user_default
                    }
                    alt=""
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                    }}
                  />
                  {user_details.first_name} {user_details.last_name}
                </div>
              ),
            });
          }
        });

        formik.setValues({
          campaign_name: result?.data?.campaign_info?.campaign_name,
          start_date: result?.data?.campaign_info?.start_date 
            ? new Date(result?.data?.campaign_info?.start_date) 
            : null,
          end_date: result?.data?.campaign_info?.end_date 
            ? new Date(result?.data?.campaign_info?.end_date) 
            : null,
          program_ids: program_ids,
          user_ids: user_ids,
        });
        setImageUri(result?.data?.campaign_info?.campaign_image_path);
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to get campaign details",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
    } catch (e) {
      console.log(e);

      toast.error(e.message ? e.message : "Failed to get campaign details", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoading(false);
    }
  };

  //get programs list
  const getProgramList = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("client_id", user?.client_id);
      formData.append("role_id", user?.role_id);
      formData.append("user_id", user?.user_id);
      let result = await handleApi("program_list", method, headers, formData);
      if (result?.success) {
        setProgramList(result?.data?.programs_list);
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to get program details",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
    } catch (e) {
      console.log(e);

      toast.error(e.message ? e.message : "Failed to get program details", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoading(false);
    }
  };
  //get users list
  const getUserList = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("client_id", user?.client_id);
      let result = await handleApi("user_list", method, headers, formData);
      if (result?.success) {
        setUserList(result?.data?.user_list);
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to get user list",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
    } catch (e) {
      console.log(e);

      toast.error(e.message ? e.message : "Failed to get user list", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (campaign_id) {
      getCampaignDetails();
    }
    getProgramList();
    getUserList();
  }, [show]);

  const options = userList.map((member) => ({
    label: `${member.first_name} ${member.last_name}`,
    value: member.user_id,
    customLabel: (
      <div className="d-flex align-items-center gap-2">
        <img
          src={member?.profile_image ? member?.profile_image : user_default}
          alt={member.first_name + ` ` + member.last_name}
          style={{ width: "24px", height: "24px", borderRadius: "50%" }}
        />
        {member.first_name} {member.last_name}
      </div>
    ),
  }));

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="program_heading">
            {" "}
            {!campaign_id ? "Create Campaign" : "Edit Campaign Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            className="rounded-pill row create_campaign_card"
            onSubmit={formik.handleSubmit}
          >
            {/* program logo */}
            {/* <div className="">
              <div className="d-flex justify-content-center">
                <img
                  src={imageUri ? imageUri : campaign}
                  alt="campaign image"
                  style={{
                    width: "auto",
                    height: "64px",
                    borderRadius: "0.7vw",
                  }}
                />
                <input
                  ref={profileImageRef}
                  type="file"
                  id="campaign_image"
                  className="d-none"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </div>
            </div>
            <div className="col-12  px-3 mt-3  ">
              <div className="row">
                <div className="col-md-6">
                  <button
                    type="button"
                    onClick={() => {
                      profileImageRef.current.click();
                    }}
                    className=" mb-2   form-control btn btn-primary rounded-pill d-flex justify-content-center align-items-center gap-1"
                  >
                    <BiCloudUpload /> Upload Image
                  </button>
                </div>
                <div className="col-md-6 ">
                  <button
                    type="button"
                    onClick={() => {
                      setImageUri("");
                      setFile(null);
                    }}
                    className={` ${
                      !imageUri ? "disable_btn" : ""
                    } form-control mb-2  btn btn-outline-custom btn-outline-primary rounded-pill d-flex justify-content-center align-items-center gap-1 `}
                    disabled={!imageUri}
                  >
                    <TbTrashX /> Delete Image
                  </button>
                </div>
              </div>
            </div> */}
            <div className="col-12">
              <label htmlFor="program_ids" className="mb-1">
                Programs
              </label>
              <div className="custom-select-container">
                <Select
                  id="program_ids"
                  name="program_ids"
                  placeholder="Select Program"
                  isDisabled={campaign_id ? true : false}
                  styles={customStyles}
                  options={programList.map((program) => {
                    return {
                      label: program?.program_name,
                      value: program?.program_id,
                    };
                  })}
                  onChange={(selected_options) => {
                 //   console.log(selected_options);
                    formik.setFieldValue("program_ids", selected_options);
                  }}
                  value={
                    formik.values.program_ids?.value
                      ? formik.values.program_ids
                      : null
                  }
                />
              </div>

              {formik.touched.program_ids && formik.errors.program_ids ? (
                <div className="text-danger text-start small">
                  {formik.errors.program_ids}
                </div>
              ) : null}
            </div>
            {/* Members list to add in campaign */}
            <div className="col-12">
              <label htmlFor="user_ids" className="mb-1">
                Members
              </label>
              <div className="custom-select-container">
                <Select
                  isMulti
                  id="user_ids"
                  name="user_ids"
                  placeholder="Select Members"
                  value={formik.values.user_ids}
                  styles={customStyles}
                  options={options}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  formatOptionLabel={(option) => option.customLabel}
                  onChange={(selectedOptions) => {
                    formik.setFieldValue("user_ids", selectedOptions);
                  }}
                />
              </div>

              {formik.touched.user_ids && formik.errors.user_ids ? (
                <div className="text-danger text-start small">
                  {formik.errors.user_ids}
                </div>
              ) : null}
            </div>

            <div className="col-12  ">
              <div className="form-group mb-2">
                <label htmlFor="campaign_name" className="mb-1">
                  Campaign Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="campaign_name"
                  placeholder="Enter Campaign Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.campaign_name}
                />
                {formik.touched.campaign_name && formik.errors.campaign_name ? (
                  <div className="text-danger text-start small">
                    {formik.errors.campaign_name}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="col-12  ">
              <div className="row">
                <div className="col-md-6 ">
                  <div className="form-group mb-2 ">
                    <label htmlFor="start_date" className="mb-1">
                      Start Date
                    </label>
                    {/* <input type="date" className="form-control"
                      id="start_date"
                      placeholder="Enter Start Date"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.start_date}
                    /> */}
                    {/* <Flatpickr
                      value={formik.values.start_date}
                      onChange={(selected_date) => {
                        formik.setFieldValue('start_date', selected_date[0])}}
                        options={{
                          dateFormat:'m/d/y',
                          minDate:!campaign_id? 'today':'',
                        
                          enableTime: false,
                          
                        }}
                      className="form-control"
                      id="start_date"
                    /> */}
                    <DatePicker
                      showIcon={false}
                      selected={formik.values.start_date}
                      onChange={(date) => {
                        formik.setFieldValue("start_date", date);
                      }}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="Select Start Date"
                      className="form-control"
                    />
                    {formik.touched.start_date && formik.errors.start_date ? (
                      <div className="text-danger text-start small">
                        {formik.errors.start_date}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className=" col-md-6">
                  <label htmlFor="end_date" className="mb-1">
                    End Date
                  </label>
                  {/* <input type="date" className="form-control"
                    id="end_date"
                    placeholder="Enter End Date"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.end_date}
                  /> */}
                  {/* <Flatpickr
                    value={formik.values.end_date}
                    onChange={(selected_date) => {
                      formik.setFieldValue('end_date', selected_date[0])

                    }}
                    options={{
                      dateFormat:'m/d/y',
                      minDate:!campaign_id? 'today':'',
                      enableTime: false,
                      
                    }}
                    className="form-control"
                    id="end_date"
                  /> */}
                  <DatePicker
                    showIcon={false}
                    selected={formik.values.end_date}
                    minDate={formik.values.start_date || undefined}
                    onChange={(date) => {
                      formik.setFieldValue("end_date", date);
                    }}
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Select End Date"
                    className="form-control"
                  />
                  {formik.touched.end_date && formik.errors.end_date ? (
                    <div className="text-danger text-start small">
                      {formik.errors.end_date}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            {/* <div className='col-12'>
            <label htmlFor="program_ids" className='mb-1'>Programs</label>
            <div className='custom-select-container'>
            <Select
             isMulti  
             id="program_ids" 
             name="program_ids"
         
             styles={customStyles}
             options={programList.map((program)=>{
             return {
                  label:program?.program_name,
                  value:program?.program_id
                }

              })}
              onChange={(selected_options)=>{
              formik.setFieldValue('program_ids',selected_options)

              }}
              value={formik.values.program_ids}

              />

            </div>
          
                 {formik.touched.program_ids && formik.errors.program_ids ? (
                  <div className='text-danger text-start small'>{formik.errors.program_ids}</div>
                ) : null}
             </div> */}
            {(user?.role_id === 2 || user?.role_id === 1) && (
              <div className="col-12">
                {isLoading ? (
                  <button
                    type="button"
                    disabled={isLoading}
                    className="my-3 btn btn-primary rounded-pill form-control "
                  >
                    processing...
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="my-3 btn btn-primary rounded-pill form-control "
                  >
                    Submit
                  </button>
                )}
              </div>
            )}
            <EditProfileImage
              setShow={setEditImage}
              show={editImage}
              uri={imageUri}
              setImageUri={setImageUri}
            />
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CampaignViewEdit;
